import React from "react";
import { Box, Stack, Avatar, Paper, keyframes } from "@mui/material";
import SparklesIcon from "@mui/icons-material/AutoAwesome";

// Animation for the typing dots
const bounce = keyframes`
  0%, 80%, 100% {
    transform: scale(0.8);
    opacity: 0.3;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
`;

const Dot = ({ delay }) => (
  <Box
    sx={{
      width: 8,
      height: 8,
      borderRadius: "50%",
      backgroundColor: "#555",
      animation: `${bounce} 1.2s infinite`,
      animationDelay: delay,
    }}
  />
);

const TypingDots = () => (
  <Stack direction="row" spacing={1} alignItems="center">
    <Dot delay="0s" />
    <Dot delay="0.2s" />
    <Dot delay="0.4s" />
  </Stack>
);

const ConversationTypingLoader = () => {
  return (
    <Box display="flex" alignItems="flex-start" px={2} py={1.5}>
      {/* Avatar */}
      <Avatar
        sx={{
          bgcolor: "grey.900",
          width: 36,
          height: 36,
          fontSize: 14,
          mr: 1.5,
        }}
      >
        <SparklesIcon fontSize="small" />
      </Avatar>

      {/* Typing Bubble */}
      <Paper
        sx={{
          px: 2,
          py: 1.2,
          borderRadius: 3,
          bgcolor: "#f5f5f5",
          boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
        }}
      >
        <TypingDots />
      </Paper>
    </Box>
  );
};

export default ConversationTypingLoader;
